module.exports = __webpack_public_path__ + "static/media/mobfootball2.10092210.png";